var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_2",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_2",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADy0lEQVR4nO2cy6ocVRSGy4EkiooOhIigoEbES0AdGTUBn0FNAr6AiIpz7wOFkDMoKGqvb1cf6gkkLxAHChoJDgQnUQfGGxqdKEZNjpCW7Smh4yCk0121dp36P1hw6NN01frXvtZau4pCCCGEEEIIIYQQQojMKMvyphDCEaAxs1Nm9jOwlSz93X0WgcOz2exG7/vdMcQY7zWzTeAPYH6Flr47CyHs9b7/0bKxsXEdcAz4ewnh/2+phxxt23a3tz+jIoSwF/h8BeEvMTM7Cdzm7dcoqOv64W58X4v4C0H4rmmafd7+Zd/yrQfxF4NQVdUebz+zpG3b3cBnfYm/EIRP0/zi7W92sD3h9ir+QhDe8vY3u6Umq612lrXfNRQtYNvr/PnAVvs1ucx2uCy3yVrXMHROO+bi35XPEYfW/18QDhVTB2i8AgBQTB0zO+XYA04WUwf4xbEHnC2mjpldcAzA+WLqmALgCxqCfDFNwu4BiI6rICumDnDYcRJ+ppg6VVXdkB4LOLT+c+na3v5nATBzCED09ju3HPDWgOJfqOv6Lm+/swI4OmAPeNfb3yxTkrZdvdC3+B+XZbnL298sqapqD/Btj0PPDyGE2739zJqmafal6oUeApAC+5C3f6Ngc3PzVuCDdQ47ygEvSVmWu1L1wip7hLTaMbN3NOavPi/UywSi+y5aaq5/x3woPb8BPknJlK6Fp3zC2e6zEGN8VjtcIYQQQgghhBBCCCFE1s/+D9R1/WDf10pZsRjjk5PPETRN8yjwmpm9D/zZPcv/EbijL/Fns9mdZvZTd610zRNm9irwSDEFYowPAG+a2ReXSah8Ddzdk/hfXSaJcwYogSfm8/k1xU6hrutbgFeAL5dIJ34P7F/XPYQQHu9+80qvfxp4uW3bm4uxAtzXlRxe7RHUrZQTXuW1AsD1wNtXewg8pTZTCWM6SF6MhfRamJSPXdfJdzM7Y2YvLpNmTOd/gZeAb9ZUVZF8CVlXVgDXmtkbfVU62/bvvgc8b2aPJTFSNV2yLnG/P/0PON7Xwe/uHl5PvhY50U1wH/XhNBlaOtXTNM09RQ6kSgXgN29RGN5+DSE87Sp+WimY2cUMxJg79YSLZvaCi/ip/mbK4nNpEJ7z2FCd93aeTMzM/goh3D9YAFKxq7fTZGZm9uEg4scYn/J2lnzt4E59u9V8DDbIwb8ln+lMzU4PEYDBXy/GSCztlIcIgLujZGwKAAqAeytEPcBfCDQE+YuBg2kOQAFwb4WoB/gLgYYgfzFwMM0B7PAACCGEEEIIIYQQQohirPwDJoWdK4SAtAYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.9fab5dd944d38212e3ef5962a3e9fe0d.svg";
export { ForwardRef as ReactComponent };